import React, { useContext, useRef } from "react";
import ArrowDown from "../../Assets/Images/Arrowdown.svg";
import FAQs from "../../Components/FAQs";
import HealthInsuranceHero from "../../Components/HealthInsuranceHero";
import CriticalIllnessTab from "../../Components/CriticalIllnessTab/CriticalIllnessTab";
import NavBar from "../../Components/NavBar";
import "./product.css";

import HomeOverlayElement1 from "../../Assets/Images/home-overlay-element-1.png";
import HomeOverlayElement3 from "../../Assets/Images/home-overlay-element-2.png";
import HomeOverlayElement2 from "../../Assets/Images/home-overlay-element-3.png";

import HomeOverlayMobileElement1 from "../../Assets/Images/critical-banner-mobile-overlay-1.png";
import HomeOverlayMobileElement3 from "../../Assets/Images/critical-banner-mobile-overlay-3.png";
import HomeOverlayMobileElement2 from "../../Assets/Images/critical-banner-mobile-overlay-2.png";

import Activation90Icon from "../../Assets/Images/activation90-icon.svg";
import ExtensiveCoverageIcon from "../../Assets/Images/extensive-coverage-icon.svg";
import FlexibilityIcon from "../../Assets/Images/flexibility-icon.svg";
import Upto80Icon from "../../Assets/Images/upto80-icon.svg";

import whyIllnessIcon1 from "../../Assets/Images/w-illness1.svg";
import whyIllnessIcon2 from "../../Assets/Images/w-illness2.svg";
import whyIllnessIcon3 from "../../Assets/Images/w-illness3.svg";
import whyIllnessIcon4 from "../../Assets/Images/w-illness4.svg";

import whyIllnessMobileIcon4 from "../../Assets/Images/w-illness-Mobile3.png";

import ProductOverviewImage from "../../Assets/Images/product-overview-image.jpg";

import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";

import { LanguageContext } from "../../Hooks/langugaeContext";
import { TransEn, TransEs } from "../../constants/HomeBannerConst";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const CriticalIllnessInsurance = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();
  // language translation code
  // const { language } = useContext(LanguageContext);
  // const translations = language === "Eng" ? TransEn : TransEs;

  const scrollToRef = useRef(null);
  const scrollToContent = () => {
    scrollToRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <>
      <NavBar />

      <section className="home-welcome terms-life-banner criticleIllness-banner container-fluid">
        <div className="criticleIllness-overlay-bg"></div>
        <div className="home-welcome-overlay-element">
          <div className="absolute w-full h-full z-[4] animate__animated animate__fadeInDown">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one hidden md:block"
              src={HomeOverlayElement2}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--one block md:hidden"
              src={HomeOverlayMobileElement2}
            />
          </div>
          <div className="absolute w-full h-full z-[4] animate__animated animate__fadeInUp">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two hidden md:block"
              src={HomeOverlayElement3}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--two block md:hidden"
              src={HomeOverlayMobileElement3}
            />
          </div>
          <div className="absolute w-full h-full md:z-[6] z-[4] animate__animated animate__fadeInUp">
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--three critical-overlay-element-web--three hidden md:block"
              src={HomeOverlayElement1}
            />
            <img
              alt="overlay-element"
              className="home-welcome-overlay-element--three critical-overlay-element-mob-three block md:hidden"
              src={HomeOverlayMobileElement1}
            />
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0">
          <div className="h-full flex items-center criticleIllness-banner-caption max-w-[552px] md:pl-0 px-4">
            <div className="relative ">
              <h1 className="mb-4 md:leading-[2.8rem] md:text-[2.5rem] text-[24px] leading-[28px] font-semibold tracking-[-0.5px]  animated fadeInUp extra-title-heading">
                {translations.criticalIllnessHeading}
              </h1>
              <p className="mb-4 text-[14px] leading-normal md:text-[14px] worldclstext max-w-[552px] animated fadeInUp extra-para-vs">
                {translations.criticalIllnessDescription}
              </p>
              <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold md:hidden block">
                <div className="flex space-x-3 text-white items-center">
                  <div
                    onClick={scrollToContent} // Attach scroll handler
                    className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
                  >
                    <img
                      src={ArrowDown}
                      alt="Scroll down arrow"
                      className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                    />
                  </div>
                  <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                    {translations.aboutUsBannerButton}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute container z-[6] left-0 right-0 bottom-16 md:block hidden">
          <div className="text-teal-900 px-8 py-2 pl-0 rounded-full text-lg font-semibold">
            <div className="flex space-x-3 text-white items-center">
              <div
                onClick={scrollToContent} // Attach scroll handler
                className="border-radius scrollarrow arrow-border flex items-center justify-center border-2 border-white rounded-full w-[88px] h-[50px] cursor-pointer"
              >
                <img
                  src={ArrowDown}
                  alt="Scroll down arrow"
                  className="animate__animated animate__bounce animate__delay-2s animate__repeat-3"
                />
              </div>
              <span className="hidden lg:block text-lg font-medium scrollToSeeMore">
                {translations.aboutUsBannerButton}
              </span>
            </div>
          </div>
        </div>
      </section>

      <section
        id="WhyChooseIllness"
        className="why-choose-illness py-20 lg:py-36"
        ref={scrollToRef}
      >
        <div className="container">
          <div className="animate__animated animate__fadeInLeft">
            <div className="text-sm text-gray-600  learnmoreacc mb-1">
              {translations.whyChooseIllness.subtitle}
            </div>
            <h2 className="text-[24px] md:text-[40px] mb-2 md:leading-[44px] leading-[28px] lg:font-normal font-bold extra-title-heading">
              <span className="font-bold">
                {translations.whyChooseIllness.titleBold}
              </span>
              <br /> {translations.whyChooseIllness.titleRegular}
            </h2>
            <p className="text-[14px] mt-4 leading-normal md:leading-[22px] mb-0 max-w-[413px] extra-para-vs WhyChooseIllness-description">
              {translations.whyChooseIllness.description}
            </p>
          </div>
          <div className="flex mt-16 md:mt-48 md:flex-row flex-col md:px-0 px-4">
            <div className="md:w-1/2 w-full">
              <div className="flex items-center pb-[2rem] max-w-[482px] animate__animated animate__fadeInLeft whyIllnessIcon-grid">
                <div className="lg:pe-[1.6rem] pe-[1rem] flex-none">
                  <img
                    src={whyIllnessIcon1}
                    className=" w-[84px]"
                    alt="not found"
                  />
                </div>
                <div className="">
                  <h3 className="text-[18px] mb-0 leading-[22px] tracking-tight">
                    {translations.whyChooseIllness.reasons.medicalDebts}
                  </h3>
                </div>
              </div>
              <div className="flex items-center pb-[2rem] max-w-[482px] animate__animated animate__fadeInLeft whyIllnessIcon-grid">
                <div className="lg:pe-[1.6rem] pe-[1rem] flex-none">
                  <img
                    src={whyIllnessIcon2}
                    className=" w-[84px]"
                    alt="not found"
                  />
                </div>
                <div className="">
                  <h3 className="text-[18px] mb-0 leading-[22px] tracking-tight">
                    {translations.whyChooseIllness.reasons.lossOfIncome}
                  </h3>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 w-full">
              <div className="flex items-center  pb-[2rem] max-w-[482px] animate__animated animate__fadeInLeft whyIllnessIcon-grid">
                <div className="lg:pe-[1.6rem] pe-[1rem] flex-none">
                  <img
                    src={whyIllnessIcon3}
                    className=" w-[84px] hidden lg:block"
                    alt="not found"
                  />
                  <img
                    src={whyIllnessIcon3}
                    className=" w-[84px] block lg:hidden"
                    alt="not found"
                  />
                </div>
                <div className="">
                  <h3 className="text-[18px] mb-0 leading-[22px] tracking-tight">
                    {translations.whyChooseIllness.reasons.educationCosts}
                  </h3>
                </div>
              </div>
              <div className="flex items-center pb-[2rem] max-w-[482px] animate__animated animate__fadeInLeft whyIllnessIcon-grid">
                <div className="lg:pe-[1.6rem] pe-[1rem] flex-none">
                  <img
                    src={whyIllnessIcon4}
                    className=" w-[84px]"
                    alt="not found"
                  />
                </div>
                <div className="">
                  <h3 className="text-[18px] mb-0 leading-[22px] tracking-tight">
                    {translations.whyChooseIllness.reasons.rehabilitation}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CriticalIllnessTab />

      <section className="relative product-overview md:pb-32 pb-16 flex flex-wrap flex-col-reverse lg:flex-col md:flex-nowrap">
        <div className="container">
          <div className="flex-1 shrink order-last lg:w-[50%] py-[40px] lg:order-first lg:px-0 px-4">
            <div className="pb-[10%] md:pb-[15%] lg:pb-[30%] hidden lg:block animate__animated animate__fadeInLeft pr-overview-right-img">
              <div className="text-sm text-gray-600 mb-1 learnmoreacc">
                {translations.productOverview.sectionTitle}
              </div>
              <div className="text-[24px] md:text-[40px] mb-2 md:leading-[44px] leading-[28px] lg:font-bold font-bold extra-title-heading">
                {translations.productOverview.heading}
              </div>
            </div>
            <div>
              <div className="flex pb-[2rem] animate__animated animate__fadeInLeft pr-overview-list-grid">
                <div className="pe-[1.8rem] flex-none">
                  <img src={Upto80Icon} className=" w-[84px]" alt="not found" />
                </div>
                <div className="max-w-[355px] pr-overview-right-col">
                  <h3 className="lg:text-[24px] text-[16px] font-semibold lg:mb-2.5 mb-2 lg:leading-[28px] leading-[20px] tracking-tight">
                    {translations.productOverview.features.upto80.title}
                  </h3>
                  <p className="lg:text-[16px] text-[14px] leading-[22px]">
                    {translations.productOverview.features.upto80.description}
                  </p>
                </div>
              </div>
              <div className="flex pb-[2rem] animate__animated animate__fadeInLeft pr-overview-list-grid">
                <div className="pe-[1.8rem] flex-none">
                  <img
                    src={Activation90Icon}
                    className=" w-[84px]"
                    alt="not found"
                  />
                </div>
                <div className="max-w-[355px] pr-overview-right-col">
                  <h3 className="lg:text-[24px] text-[16px] font-semibold lg:mb-2.5 mb-2 lg:leading-[28px] leading-[20px] tracking-tight">
                    {translations.productOverview.features.activation90.title}
                  </h3>
                  <p className="lg:text-[16px] text-[14px] leading-[22px] ">
                    {
                      translations.productOverview.features.activation90
                        .description
                    }
                  </p>
                </div>
              </div>
              <div className="flex pb-[2rem] animate__animated animate__fadeInLeft pr-overview-list-grid">
                <div className="pe-[1.8rem] flex-none">
                  <img
                    src={FlexibilityIcon}
                    className="w-[84px]"
                    alt="not found"
                  />
                </div>
                <div className="max-w-[355px] pr-overview-right-col">
                  <h3 className="lg:text-[24px] text-[16px] font-semibold lg:mb-2.5 mb-2 lg:leading-[28px] leading-[20px] tracking-tight">
                    {translations.productOverview.features.flexibility.title}
                  </h3>
                  <p className="lg:text-[16px] text-[14px] leading-[22px] ">
                    {
                      translations.productOverview.features.flexibility
                        .description
                    }
                  </p>
                </div>
              </div>
              <div className="flex lg:pb-[2rem] animate__animated animate__fadeInLeft pr-overview-list-grid">
                <div className="pe-[1.8rem] flex-none">
                  <img
                    src={ExtensiveCoverageIcon}
                    className=" w-[84px]"
                    alt="not found"
                  />
                </div>
                <div className="max-w-[355px] pr-overview-right-col">
                  <h3 className="lg:text-[24px] text-[16px] font-semibold lg:mb-2.5 mb-2 lg:leading-[28px] leading-[20px] tracking-tight">
                    {
                      translations.productOverview.features.extensiveCoverage
                        .title
                    }
                  </h3>
                  <p className="lg:text-[16px] text-[14px] leading-[22px]">
                    {
                      translations.productOverview.features.extensiveCoverage
                        .description
                    }
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative lg:absolute w-[100%] lg:w-[50%] pl-[16px] right-0">
          <div className="pb-[12px] block lg:hidden animate__animated animate__fadeInLeft">
            <div className="text-sm text-gray-600 mb-1 learnmoreacc">
              Critical Illness
            </div>
            <div className="lg:text-[40px] lg:leading-[44px] text-[24px] leading-[28px] tracking-tight font-semibold">
              Product overview
            </div>
          </div>
          <div className="flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
            <div className="lg:ml-0   md:mb-0 max-h-[688px] animate__animated animate__fadeInRight">
              <img
                src={ProductOverviewImage}
                width={"100%"}
                className="object-cover md:rounded-bl-[600px] rounded-bl-[244px] max-h-[900px]"
                alt="not found"
              />
            </div>
          </div>
        </div>
      </section>

      {/* <FAQs /> */}
      <HealthInsuranceHero />
    </>
  );
};

export default CriticalIllnessInsurance;
